<template>
	<transition name='fade' v-if='showLoader'>
		<div class="loader-modal" :class="loaderStyle=='dark'?'dark':'light'">
			<div class="loader-body" :class="{'no-icon':!showIcon}">

				<div v-if='showIcon'>
					<div class="loader-icon loader-icon-1" v-if="iconType==1">
						<div class="line line1"></div>
						<div class="line line2"></div>
						<div class="line line3"></div>
					</div>

					<div class="loader-icon loader-icon-3" v-if="iconType==3">
						<div class="dot dot1"></div>
						<div class="dot dot2"></div>
						<div class="dot dot3"></div>
					</div>
				</div>
				<p class="tips">{{tips}}</p>
			</div>
		</div>
	</transition>
</template>

<script>
	/*
								 @param boolean	showLoader 是否显示loader
								 @param boolean	showIcon 是否显示加载图标，默认true显示
								 @param number  iconType 显示的加载图标的样式,默认1
								 @parma string  tips  显示的提示文字
								 @parma number	duration 持续时间，默认1200
								 @parma string  loaderStyle loader的风格,参数：dark,light,默认dark
									*/

	export default {
		name: 'Loader',
		data() {
			return {
				showLoader: false,
				showIcon: true,
				iconType: 1,
				loaderStyle: 'dark',
				duration: 1000,
				tips: '默认提示文字'
			}
		},
		methods: {
			hide() {
				this.showLoader = false;
			},
			show() {
				this.showLoader = true;
			},
			autoClose() {
				setTimeout(() => {
					this.showLoader = false;
				}, this.duration)
			}

		},
		mounted() {
			this.autoClose();
		}
	}
</script>

<style scoped lang='less'>
	.loader-modal {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 999;
		.tips {
			width: 100%;
			text-align: center;
		}
		&.dark {
			background-color: rgba(0, 0, 0, .4);
			.loader-body {
				background: #1a1a1a;
			}
			.tips {
				color: #fff;
			}
		}
		&.light {
			background-color: rgba(155, 155, 155, .4);
			.loader-body {
				background: #fff;
			}
			.tips {
				color: #333;
			}
		}
	}
	
	.loader-body {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		width: 168px;
		height: 96px;
		border-radius: 5px;
		&.no-icon {
			width: 192px;
			height: 42px;
			padding: 10px 0;
			line-height: 42px;
		}
	}
	
	.loader-icon {
		position: relative;
		width: 100%;
		height: 66px;
		border-radius: 50%;
		display: inline-block;
		vertical-align: middle;
	}
	
	.loader-icon-1 .line {
		width: 8px;
		height: 24px;
		position: absolute;
		border-radius: 5px;
		bottom: 14px;
		background: -webkit-gradient(linear, left top, left bottom, from(#1ee95d), to(#5714ce));
		background: -webkit-linear-gradient(top, #1ee95d, #5714ce);
		background: linear-gradient(to bottom, #1ee95d, #5714ce);
	}
	
	.line1 {
		left: 60px;
		-webkit-animation: line-grow 0.5s ease alternate infinite;
		animation: line-grow 0.5s ease alternate infinite;
	}
	
	.line2 {
		left: 80px;
		-webkit-animation: line-grow 0.5s 0.2s ease alternate infinite;
		animation: line-grow 0.5s 0.2s ease alternate infinite;
	}
	
	.line3 {
		left: 100px;
		-webkit-animation: line-grow 0.5s 0.4s ease alternate infinite;
		animation: line-grow 0.5s 0.4s ease alternate infinite;
	}
	
	.loader-icon.loader-icon-3 {
		display: block;
		width: 60px;
		margin: 0 auto;
	}
	
	.loader-icon-3 .dot {
		width: 10px;
		height: 10px;
		background: #00e676;
		border-radius: 50%;
		position: absolute;
		top: calc(50% - 5px);
	}
	
	.dot1 {
		left: 0px;
		-webkit-animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
		animation: dot-jump 0.5s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
	}
	
	.dot2 {
		left: 20px;
		-webkit-animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
		animation: dot-jump 0.5s 0.2s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
	}
	
	.dot3 {
		left: 40px;
		-webkit-animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
		animation: dot-jump 0.5s 0.4s cubic-bezier(0.77, 0.47, 0.64, 0.28) alternate infinite;
	}
	
	@-webkit-keyframes line-grow {
		0% {
			height: 0;
		}
		100% {
			height: 36px;
		}
	}
	
	@keyframes line-grow {
		0% {
			height: 0;
		}
		100% {
			height: 36px;
		}
	}
	
	@keyframes dot-jump {
		0% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		100% {
			-webkit-transform: translateY(-18px);
			transform: translateY(-18px);
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Loader.vue